"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ReportPreferenceEntity_1 = __importDefault(require("./Entity/ReportPreferenceEntity"));
var ReportPreference = /** @class */ (function () {
    function ReportPreference(session) {
        this.reportPreference = new ReportPreferenceEntity_1.default(session);
    }
    ReportPreference.prototype.upsert = function (reportPreference) {
        return this.reportPreference.upsert(reportPreference);
    };
    ReportPreference.prototype.delete = function (id) {
        return this.reportPreference.service.delete(id);
    };
    return ReportPreference;
}());
exports.default = ReportPreference;
//# sourceMappingURL=ReportPreference.js.map